import { render, staticRenderFns } from "./PlayersKycGrid.vue?vue&type=template&id=028940c8&"
import script from "./PlayersKycGrid.vue?vue&type=script&lang=js&"
export * from "./PlayersKycGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports